export default {
  getAll: 'integrations/GET_ALL',
  getAllSuccess: 'integrations/GET_ALL_SUCCESS',
  getAllFailure: 'integrations/GET_ALL_FAILURE',

  update: 'integrations/UPDATE',
  updateSuccess: 'integrations/UPDATE_SUCCESS',
  updateFailure: 'integrations/UPDATE_FAILURE',

  sync: 'integrations/SYNC',
  syncSuccess: 'integrations/SYNC_SUCCESS',
  syncFailure: 'integrations/SYNC_FAILURE',
};
